import { Inject, inject, Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { LoggerWrapper } from '../../shared/providers/logger/logger-wrapper.service';
import { LoggerFactory } from '../../shared/providers/logger/logger-factory.service';
import { DOCUMENT } from '@angular/common';
import { OpenIdConfiguration } from '../oidc-security.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this);

  constructor(
    private readonly urlService: UrlService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  redirectToAdfsLoginPage(config: OpenIdConfiguration): void {
    this.urlService.getAuthorizeUrl(config).subscribe((url: string) => {
      if (!url) {
        this.logger.error(undefined, '[oidc] Cannot redirect to undefined URL');
        return;
      }
      this.redirectTo(url);
    });
  }

  private redirectTo(url: string) {
    this.document.location.href = url;
  }
}
